<cv-tab-group>
	<cv-tab [icon]="'fa-info-circle'" [active]="true">
		<div [ngClass]="{
				'tab-content': true,
				'card-rule-info': ruleType === messageType.INFO,
				'card-rule-warnig': ruleType === messageType.WARNING,
				'card-rule-error': ruleType === messageType.ERROR
			}">
			<h5 class="tab-content__title">TYPE</h5>
			<span class="tab-content__text">{{ info.photoType || 'N/A' }}</span>
			<h5 class="tab-content__title">PATH</h5>
			<span class="tab-content__text">{{ info.photoJsonPath || 'N/A' }}</span>
			<h5 class="tab-content__title">
				DESCRIPTION
			</h5>
			<span class="tab-content__text">{{ info.photoDescription || 'N/A' }}</span>
		</div>
	</cv-tab>
	<cv-tab [icon]="'fa-map-marker-alt'" *ngIf="SchemaType === schema.INSPECTION_R">
		<div class="tab-content">
			<a href="javascript:void(0)"> {{ info.photoLatitude }},{{ info.photoLongitude }}</a>
			<cv-component-map [mapConfiguration]="mapConfiguration" [zoom]="15" [height]="'150px'">
			</cv-component-map>
		</div>
	</cv-tab>
</cv-tab-group>